import { IMachine } from '../machines/machines'
import { machines } from '../machines/machines-sidecar'
import { advanceTask } from './advanceTask'
import { jobLogger } from './jobLogger-sidecar'
import { IJob, registerJob } from './jobs'
import { createTask_custom } from './taskCustom'
import { createTask_goToMachine } from './taskGoToMachine'
import { createTask_placeInEmptySpace } from './taskPlaceInEmptySpace'
import { createTask_putAway } from './taskPutAway'

export const register = () => registerJob('harvest', runJob_harvest)

export function runJob_harvest(job: IJob) {
  jobLogger.assertJobType(job, 'harvest')

  let f = (c: IMachine) => c.data.type === 'grower'

  let mc = jobLogger.assertMachine(job, f)
  let m = jobLogger.assertReserved(job)

  // Seed job tasks
  if (job.tasks.length === 0) {
    job.tasks = []

    // Go to grower
    let task = createTask_goToMachine(mc.i, mc.j, f)
    job.tasks.push(task)

    task = createTask_custom(mc.i, mc.j, (t) => {
      machines.harvest(mc, m)
      jobLogger.succeedTask(job, t)
    })
    job.tasks.push(task)

    // Put down in open spot
    task = createTask_putAway(m.i, m.j)
    // task = createTask_placeInEmptySpace(m.i, m.j)
    job.tasks.push(task)

    return
  }

  if (job.tasks.length > 0) {
    advanceTask(job)
  }
}
// export function advanceJob_moveToStack(job: IJob) {}
